<template>
  
  <div class="cataloghi">

    <h4 class="mt-0 uc title is-4">Cataloghi</h4>

    <p>Da qui puoi gestire l'upload dei cataloghi nelle varie lingue.</p>

  </div>

</template>

<script>
export default {



}
</script>

<style scoped lang="scss">
.cataloghi{
  margin-bottom: 3em;
}
</style>
